import React from 'react';

import FetchData from 'components/map/FetchData';

import Wrapper from './Wrapper';

const MainWrapper = () => (
  <>
    <FetchData />
    <Wrapper />
  </>
);

export default MainWrapper;
